import { render, staticRenderFns } from "./TotalCategoriesGroupCount.vue?vue&type=template&id=088bd242&scoped=true&"
import script from "./TotalCategoriesGroupCount.vue?vue&type=script&lang=js&"
export * from "./TotalCategoriesGroupCount.vue?vue&type=script&lang=js&"
import style0 from "./TotalCategoriesGroupCount.vue?vue&type=style&index=0&id=088bd242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bd242",
  null
  
)

export default component.exports